<template>
  <div :class="['youtube-consent-placeholder', { 'youtube-consent-placeholder--compact': compact }]">
    <div class="youtube-consent-placeholder__title">
      {{ tOr('common.youtube_blocked_title', 'Contenido de YouTube bloqueado') }}
    </div>
    <p class="youtube-consent-placeholder__text mb-0">
      {{ tOr('common.youtube_blocked_description', 'Para ver vídeos embebidos necesitas aceptar las cookies externas de YouTube.') }}
    </p>
    <button type="button" class="btn btn-outline-primary btn-sm mt-3" @click="openPreferences">
      {{ tOr('common.cookie_manage_preferences', 'Configurar') }}
    </button>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'YouTubeConsentPlaceholder',
  props: {
    compact: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    ...mapActions('cookieConsent', ['openPreferences']),
    tOr(key, fallback) {
      return typeof this.$te === 'function' && this.$te(key) ? this.$t(key) : fallback;
    },
  },
};
</script>

<style scoped>
.youtube-consent-placeholder {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  min-height: 220px;
  padding: 1.2rem;
  border: 1px dashed rgba(14, 116, 144, 0.35);
  border-radius: 16px;
  background: linear-gradient(135deg, rgba(240, 249, 255, 0.95), rgba(248, 250, 252, 0.95));
}

.youtube-consent-placeholder--compact {
  min-height: 180px;
}

.youtube-consent-placeholder__title {
  font-weight: 700;
  color: #0f172a;
}

.youtube-consent-placeholder__text {
  color: #475569;
  margin-top: 0.3rem;
}
</style>